import { useState, useCallback } from "react";
import { Check } from "lucide-react";
import CopyIcon from "../../settings/CopyIcon";
import { colors } from "../../../styles/colors";

interface QuestionReadyLinkItemProps {
  title: string;
  subtitle: string;
  copyUrl?: string;
}

const QuestionReadyLinkItem = ({
  title,
  subtitle,
  copyUrl,
}: QuestionReadyLinkItemProps) => {
  const [copied, setCopied] = useState(false);

  const handleClick = useCallback(() => {
    if (!copyUrl) return;
    navigator.clipboard
      .writeText(copyUrl)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => {});
  }, [copyUrl]);

  const isClickable = !!copyUrl;

  return (
    <div
      className={`link-item ${isClickable ? "link-item-clickable" : ""}`}
      onClick={isClickable ? handleClick : undefined}
      onKeyDown={
        isClickable
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
              }
            }
          : undefined
      }
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      aria-label={isClickable ? title : undefined}
    >
      <div className={`link-item-icon${copied ? " copied" : ""}`}>
        {copied ? (
          <Check color={colors.green} size={20} strokeWidth={2.5} />
        ) : (
          <CopyIcon color="#004EF7" width={19} height={22} />
        )}
      </div>
      <div className="link-item-texts">
        <p className="link-item-title">{title}</p>
        <p className="link-item-subtitle">
          {copied ? "הקישור הועתק!" : subtitle}
        </p>
      </div>
    </div>
  );
};

export default QuestionReadyLinkItem;
